import BaseDropdown from "../components/BaseDropdown";
import BaseButton from "../components/BaseButton";

export default {
  install(Vue) {
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseButton.name, BaseButton);
  }
};
